import { connect } from 'react-redux';
import { AppState } from '../../app-state';
import { PermissionTable } from '../components/permission-table.component';

export default connect((state: AppState) => ({
  documentSets: state.documentSets.entities,
}))(PermissionTable);
